export const SOLUTION_METRICS_DISPLAY_VALUES = {
  // Number of deployments
  ZERO: '0',
  ONE: '1',
  TWO_TO_FOUR: '2-4',
  FIVE_PLUS: '5+',
  // Time periods (for sales cycle, implementation time, time to value)
  ONE_TO_THREE_MONTHS: '1-3 months',
  FOUR_TO_SIX_MONTHS: '4-6 months',
  SEVEN_TO_NINE_MONTHS: '7-9 months',
  TEN_TO_TWELVE_MONTHS: '10-12 months',
  TWELVE_PLUS_MONTHS: '12+ months',
};
